module.exports = ".tab {\n  margin-right: 64px;\n  margin-top: 21px;\n  padding: 9px 0;\n  font-weight: bold;\n  font-size: 25px; }\n\n.active {\n  border-bottom: solid 3px #cada2a; }\n\n.mt-64 {\n  margin-top: 64px; }\n\n.p-32 {\n  padding: 32px 0 32px 0; }\n\n.mt-24 {\n  margin-top: 24px; }\n\n.ml-32 {\n  margin-left: 32px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/contratos/admin-contratos-novo/admin-contratos-novo.component.scss
// module id = ./src/app/components/admin/contratos/admin-contratos-novo/admin-contratos-novo.component.scss
// module chunks = main